import useElement from "backend/hooks/elements/useElement";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import ToolbarWithMeasureName from "components/toolbars/ToolbarWithMeasureName";
import DivisionGrid from "design/components/tables/DivisionGrid";
import Page from "design/pages/Page";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import React from "react";

const Division = () => {
  const ctx = useAppContext();
  const link = useLink();
  const {
    data,
    isLoading: isDataLoading,
    isError,
    isPreviousData,
    isRefetching,
  } = useHierarchy(ctx.elementId);

  const { data: element } = useElement(ctx.elementId);

  return (
    <Page
      isLoading={!data || isDataLoading || isRefetching || isPreviousData}
      Toolbar={ToolbarWithMeasureName}
    >
      {data ? (
        <DivisionGrid
          elements={data?.sort((a, b) => a.symbol.localeCompare(b.symbol))}
          onSelect={(el) => {
            link({ page: "StrategyMap", meaId: el.topelement });
          }}
        />
      ) : null}
    </Page>
  );
};
export default Division;
